import React from 'react';

export default function Empty(props) {
    const { title } = props;
    return <div className="p_100 text-center">{title}</div>;
}
